import React, { useEffect, useState } from 'react';
import { certificateService } from '../services/supabaseClient';
import { certificatePdf } from '../utils/certificate';

function formatDate(value) {
  if (!value) return '—';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
}

export default function Certificates() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      setError('');
      try {
        const data = await certificateService.getAll();
        setRows(data || []);
      } catch (err) {
        setError(err.message || 'Unable to load certificates.');
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  const personName = row =>
    `${row.students?.first_name || ''} ${row.students?.last_name || ''}`.trim();

  const partnerLabel = row =>
    row.partners?.company_name ||
    [row.partners?.first_name, row.partners?.last_name].filter(Boolean).join(' ') ||
    '—';

  // Certificates.jsx mein download function ko refine karein:
const download = async (row) => {
  if (row.pdf_url) {
    // Agar storage URL hai toh naye tab mein kholein
    window.open(row.pdf_url, '_blank', 'noopener,noreferrer');
  } else {
    // Fallback: Agar URL miss ho gaya ho toh on-the-fly generate karein
    const verifyUrl = `${window.location.origin}/verify/${row.id}`;
    await certificatePdf({
      personName: personName(row),
      contentName: row.course?.name || '',
      certificateId: row.certificate_id || row.id,
      uuid: row.id,
      verifyUrl
    });
  }
};
  return (
    <div className="panel">
      <div className="panel-head">
        <div>
          <h2>Certificates</h2>
          <p>Issued certificate IDs, verification references and PDF status.</p>
        </div>
      </div>

      {error && <div className="error">{error}</div>}

      <div className="table-wrap">
        <table>
          <thead>
            <tr>
              <th>Certificate ID</th>
              <th>Person</th>
              <th>Email</th>
              <th>Course</th>
              <th>Partner</th>
              <th>UUID</th>
              <th>Issue Date</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {loading && (
              <tr><td colSpan={8} className="empty">Loading...</td></tr>
            )}

            {!loading && rows.map(row => (
              <tr key={row.id}>
                <td><b>{row.certificate_id || '—'}</b></td>
                <td>{personName(row)}</td>
                <td>{row.students?.email || '—'}</td>
                <td>{row.course?.name || '—'}</td>
                <td>{partnerLabel(row)}</td>
                <td className="mono">{row.id}</td>
                <td>{formatDate(row.issue_date)}</td>
                <td>
                  <button type="button" onClick={() => download(row)}>
                    Download
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {!loading && !rows.length && <div className="empty">No certificates issued yet.</div>}
      </div>
    </div>
  );
}